"use strict";

exports.__esModule = true;
exports.AlertsDescription = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Time = require("../../../Time");
var _chartUtils = require("../utils/chartUtils");
var _styles = require("../styles");
var _StackedBarChart = require("../../../Recharts/Charts/StackedBarChart");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var COLORS = ["#00A796", "#F6928F", "#6FC376", "#FBBC6D", "#B1DAAE", "#CDA5CD", "#5DA5DA", "#C1C1C1"];
var AlertsDescription = exports.AlertsDescription = function AlertsDescription(_ref) {
  var data = _ref.data,
    period = _ref.period,
    title = _ref.title,
    width = _ref.width;
  var time = _react["default"].useContext(_Time.TimeContext);
  var ref = _react["default"].useRef(null);
  var _React$useState = _react["default"].useState([]),
    formattedData = _React$useState[0],
    setFormattedData = _React$useState[1];
  (0, _react.useEffect)(function () {
    setFormattedData(groupData(data || []));
  }, []);
  var _period$split = period.split("/"),
    start = _period$split[0],
    end = _period$split[1];
  var colors = data.map(function (item) {
    return item.description;
  }).filter(function (item, index, array) {
    return array.indexOf(item) === index;
  }).map(function (item, index) {
    return {
      key: item,
      color: COLORS[index % COLORS.length]
    };
  });
  var selectedInterval = (0, _chartUtils.getSelectedInterval)({
    start: start,
    end: end
  });
  var chartProps = (0, _chartUtils.getChartProps)({
    start: start,
    end: end
  }, {
    selectedInterval: selectedInterval,
    timezone: time.timezone,
    hideAxis: true
  }, {
    enableYDomain: true,
    minYValue: 0,
    maxYValue: Math.max.apply(Math, formattedData.map(function (item) {
      return item.sum;
    })),
    hideAxis: false
  }, {
    yValueName: "",
    xValueFormat: "YYYY-MM-DD"
  });
  chartProps.tooltipProps.xValueFormatter = function (data) {
    var _data$;
    return (_data$ = data[0]) == null ? void 0 : _data$.name;
  };
  chartProps.tooltipProps.yValueFormatter = function (data) {
    return data.reduce(function (yValues, item) {
      return [].concat(yValues, [{
        name: item.name,
        color: item.fill,
        value: item.value
      }]);
    }, []);
  };
  return /*#__PURE__*/_react["default"].createElement(_styles.ChartWrapper, {
    ref: ref,
    "data-testid": "AlertsAnalysis.AlertsDescriptionsChart.container"
  }, /*#__PURE__*/_react["default"].createElement(_styles.ChartTitle, null, title), /*#__PURE__*/_react["default"].createElement(_StackedBarChart.StackedBarChart, {
    width: width,
    height: 400,
    series: formattedData,
    colors: colors,
    data: formattedData.map(function (item) {
      return {
        key: item.key
      };
    }),
    xAxisProps: chartProps.xAxisProps,
    yAxisProps: chartProps.yAxisProps,
    tooltipProps: chartProps.tooltipProps
  }));
};
var groupData = function groupData(data) {
  return (0, _chartUtils.sumAlertCounts)(data, function (item) {
    return item.description;
  }).map(function (item) {
    var _ref2;
    return _ref2 = {
      key: item.key,
      sum: item.count,
      keys: [{
        key: item.key
      }]
    }, _ref2[item.key] = item.count, _ref2;
  });
};